const appConfig = {
  apiPrefix: "/api",
  authenticatedEntryPath: "/app/affiliate/dashboard",
  unAuthenticatedEntryPath: "/affiliate/sign-in",
  tourPath: "/affiliate/sign-in",
  enableMock: true,
  pagePerData: 10,
  configurationPagePerData: 8,
};

export default appConfig;
